import { FunctionComponent } from 'react';
import clsx from 'clsx';
import styles from './BusinessMoment.module.scss';
import Checkbox from 'components/UI/V3/Forms/Checkbox';
import { HourField } from 'components/UI/V3/Forms/HourField';

interface Props {
    label?: string;
    selected?: boolean;
    feedingMoment: string;
    onSelected?: (selected: boolean) => void;
    onChange: (feedingMoment: string) => void;
    className?: string;
    errorMessage?: string;
}

export const BusinessMoment: FunctionComponent<Props> = props => {
    const hasError = props.errorMessage !== undefined;

    const onSelectedHandler = (value: boolean): void => {
        props.onSelected?.(value);
    };

    const onChangeOpenHandler = (feedingMoment: string): void => {
        props.onChange(feedingMoment);
    };

    return (
        <div className={clsx(styles.container, props.className)}>
            {props.onSelected && (
                <div
                    className={clsx(styles.label, {
                        [styles.error]: hasError
                    })}
                >
                    <Checkbox
                        label={props.label}
                        onChange={onSelectedHandler}
                        checked={props.selected || false}
                    />
                    {hasError && <p className={clsx(styles.error, styles.errorMessage)}>{props.errorMessage}</p>}
                </div>
            )}

            <div className={styles.hour}>
                <HourField
                    value24Hs={props.feedingMoment}
                    onChange={onChangeOpenHandler}
                    disabled={!props.selected}
                    error={hasError}
                />
            </div>
        </div>
    );
};

export default BusinessMoment;
